import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setHasShared } from "../redux/actionCreators/makeActionCreator";
import Button from "./common/Button";
import posthog from "posthog-js";
import toastService from "../toastService/";

function FacebookShare({ link, inDrawer }) {
  const dispatch = useDispatch();

  useEffect(() => {
    // Script for Facebook login
    window.fbAsyncInit = function () {
      // eslint-disable-next-line no-undef
      FB.init({
        appId: "409992566301158",
        cookie: true,
        xfbml: true,
        version: "v4.0",
      });

      // eslint-disable-next-line no-undef
      FB.AppEvents.logPageView();
    };

    (function (d, s, id) {
      let js;
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.setAttribute("async", true);
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  }, []);

  function shareOnFb(link) {
    FB.ui(
      {
        display: "popup",
        method: "share",
        href: link,
      },
      (response) => {
        if (response && !response.error_message) {
          dispatch(setHasShared(true));
          toastService.successMessage("Success!");
          if (!inDrawer) {
            window.scrollTo({ top: 0 });
          }
        } else if (response) {
          toastService.errorMessage("Something went wrong, please try again");
        }
      }
    );
  }

  const fbLink =
    "https://www.facebook.com/dialog/share?" +
    "app_id=295424249499527" +
    "&display=popup" +
    `&href=${link}` +
    `&redirect_uri=https://gainful.com/app/referral`;

  return (
    <>
      <Button
        variant="primary"
        color="info"
        href={fbLink}
        onClick={() => {
          posthog?.capture("referred_by_facebook", { logged_in: true });
        }}
      >
        Share on Facebook
      </Button>
    </>
  );
}

export default FacebookShare;
